module.exports = __webpack_public_path__ + "img/img_01@2x.53be8a34.png";